import {useState,useEffect} from 'react';
import './App.css';

import ClipLoader from "react-spinners/ClipLoader";
import SubGroup from './SubGroup';
function App() {

  const [search,setSearch]=useState("")

  const [categories,setCategories]=useState(null)
  const [page,setPage]=useState(1)
  const [products,setProducts]=useState(null)
  const [total,setTotal]=useState(0)

  const [loading,setLoading]=useState(false)
  const [selectedCategory, setSelectedCategory] = useState(
    window.location.pathname.split("/")[
      window.location.pathname.split("/").length - 1
    ]
  );

  const getCategories=()=>{
    fetch('https://proberk.com/core/categories.php').then(res=>res.json()).then(res=>{
      setCategories(res.data)
    })
  }
  const getProducts = async (
    category_id = window.location.pathname.split("/")[
      window.location.pathname.split("/").length - 1
    ],
    restart = page
  ) => {
    setLoading(true);
    if (restart == "ok") {
      const reset = await setPage(1);
      setProducts([]);
    }
    fetch(
      "https://proberk.com/core/products.php?limit=9&search=" +
        search +
        "&page=" +
        (restart == "ok" ? 1 : page) +
        "&category_id=" +
        (category_id == "yok" ? "yok" : category_id)
    )
      .then((res) => res.json())
      .then(async (res) => {
        let prod = await products;
        prod =
          (await prod) != null && restart != "ok"
            ? prod.concat(res.data)
            : res.data;
        // console.log(res.data)
        setProducts(prod);
        setTotal(res.total);
        setPage(page * 1 + 1);
        setLoading(false);
      });
  };

  const getSearchedProducts=()=>{
    getProducts(selectedCategory!=null ? selectedCategory.slug :  "yok","ok")
  }

  const selectCategory=(x)=>{
    
    setSelectedCategory(x)
    console.log(x)
    getProducts(x.slug,"ok")
  }



  useEffect(()=>{
    if(categories==null){
      getCategories()
      getProducts(
        window.location.pathname.split("/")[
          window.location.pathname.split("/").length - 1
        ] == null
          ? "yok"
          : window.location.pathname.split("/")[
              window.location.pathname.split("/").length - 1
            ],
        "ok"
      );
    }
    
  },[categories])



  return (
    <div className="App">
      
      <div className="filter_form-wrapper w-form">
          <div id="wf-form-filter" name="wf-form-filter" onSubmit={(e)=>e.preventDefault()} data-name="filter" method="get" fs-cmsfilter-element="filters" className="filter_form">
            <div className="filter_wrapper wf-section">
              <div className="_80pd-section-form">
                <div className="container-1218px-24pd">
                  <div className="filter_grid">
                    <div className="filter_column">
                      {/* <div className="filter_block"><input type="text" className="filter_search-field w-input" maxlength="256" name="field" data-name="Field" placeholder="Kelime veya Ürün Kodu Ara " id="field" required=""></div> */}
                      <div className="filter_block">
                        <div className="filter_block-header">
                          <div className="filter_results-text"><span fs-cmsfilter-element="results-count" className="text-color-green">{total}</span> üründen <span fs-cmsfilter-element="items-count">{products==null ? 0 : products.length}</span> adet gösteriliyor.</div>
                          <div className="hide">
                            <div className="fs-cmsfilter_highlight">highlight</div>
                          </div>
                          <a style={{cursor:'pointer'}} fs-cmsfilter-element="reset" className="filter_reset-all text-color-green" onClick={()=>{setSearch("");setSelectedCategory(null);setSelectedCategory(null);getProducts("yok","ok")}}>Hepsini Temizle</a>
                        </div>
                      </div>
                      <div className="filter_block" style={{width:'100%'}}>
                        <div className="filter_block-header" style={{width:'100%'}}>
                          <div className="heading-h3-24px-700-bold" style={{display:'flex',padding:1,width:'100%'}}>
                            <input onKeyUp={(e)=>{
                              if(e.keyCode==13){
                                getSearchedProducts()
                              }
                            }} style={{border:'none',height:40,outline:'none',borderBottom:'1px solid #dfdfdf'}} placeholder='Ara...' value={search} onChange={e=>setSearch(e.target.value)}  />
                            
                              <div
                              onClick={getSearchedProducts}
                              style={{backgroundColor:'#eee',width:50,position:'absolute',right:7,borderRadius:20,display:'flex',justifyContent:'center',alignItems:'center',height:40,cursor:'pointer'}}
                              ><svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                              
                              
                              width="12.000000pt" height="12.000000pt" viewBox="0 0 512.000000 512.000000"
                              preserveAspectRatio="xMidYMid meet">

                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                fill="#000000" stroke="none">
                                <path d="M1910 4675 c-1066 -146 -1734 -1222 -1389 -2238 166 -489 569 -893
                                1059 -1061 506 -172 1067 -98 1506 199 l96 66 603 -608 603 -608 154 153 153
                                152 -606 606 -607 606 65 95 c410 605 381 1416 -72 1998 -85 108 -250 266
                                -365 347 -338 240 -788 349 -1200 293z m507 -330 c305 -68 578 -230 765 -453
                                158 -188 251 -374 305 -605 24 -98 27 -134 27 -292 1 -250 -29 -388 -130 -604
                                -91 -194 -246 -384 -423 -517 -152 -114 -372 -211 -569 -251 -123 -25 -404
                                -24 -522 1 -564 121 -977 531 -1097 1089 -14 63 -18 128 -18 282 1 182 3 209
                                27 305 32 125 62 208 113 310 201 400 587 680 1034 750 88 14 404 4 488 -15z"/>
                                </g>
                              </svg>
                            </div>
                              

                          </div>
                        </div>
                        <div className="filter_block-header" style={{display:'flex',borderTop:'1px solid #dfdfdf'}}>
                          <h3 className="heading-h3-24px-700-bold">Ürün Kategorileri </h3>
                          <a style={{cursor:'pointer'}} fs-cmsfilter-reset="make" fs-cmsfilter-element="reset" onClick={()=>{setSelectedCategory(null);setSelectedCategory(null)}} className="filter_reset"></a>
                        </div>
                        <div className="filter_options">
                          <ul role="list" className="collection-list-wrapper">
                            <li className="collection-list"><label className="radio-button-field w-radio">
                                {/* <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div><input type="radio" id="promosyon_urun" name="Urunler" value="promosyon_urun" data-name="Urunler" required="" style="opacity:0;position:absolute;z-index:-1"><span className="radio-button-label w-form-label" htmlFor="promosyon_urun">Promosyon Ürünleri</span> */}
                              </label><label className="radio-button-field w-radio">
                                {/* */}
                              </label></li>
                            {
                              categories==null || categories.length<1 ? 
                              <li className="empty-state">
                                <div className="empty-text">Kategori bulunamadı.</div>
                              </li>
                              :
                              <>
                              {
                                categories.filter(x=>x.parent_category_id==null).map(x=>{
                                  return (
                                    <SubGroup key={"sub-ss-"+(Math.floor(Math.random()*100))+x.slug} categories={categories} y={x} x={x} selectedCategory={selectedCategory} selectCategory={selectCategory} setSelectedCategory={setSelectedCategory}  />
                                  )
                                })
                              }
                              
                              
                              </>
                              
                            }
                          </ul>
                        </div>
                      </div>
                    
                    </div>
                    <div className="filter_content">
                      
                      
                    
                            {
                              products==null || products.length<1 ? 
                              <div fs-cmsfilter-element="empty" className="filter_empty"><img src="images/error.svg" loading="lazy" alt="" className="filter_empty-icon" />
                                  {loading?
                                  <center><ClipLoader loading={loading} /></center>
                                  :
                                  <div className="text-block-5">Arama sonucu bulunamadı.</div>
                                  }
                              </div>
                              :
                              <div  className="content_filter">
                                <div className="product-list-wrapper">
                                  
                                  <ul role="list" className="content_collection-list-grid">
                                    {loading?
                                    <>
                                    <li></li>
                                    <li>
                                      <center><ClipLoader loading={!loading} /></center>
                                    </li>
                                    <li></li>
                                    </>
                                    :<></>
                                    }
                                    {
                                      products.map((x,index)=>{
                                        return(
                                          <li key={"pr-"+index} className="list-item">
                                            <div className="product-card-wrapper">
                                              <div data-w-id="868df184-c0e5-776f-1538-5257bbf09827" className="product-card-image-inside-card">
                                                <div data-w-id="868df184-c0e5-776f-1538-5257bbf09828"  style={{cursor:'pointer'}} onClick={()=>window.location.href=x.url!=undefined ? x.url : "https://proberk.com"} className="image-card-wrapper">
                                                  <a href="#" className="styled-a styled-a styled-a icon-link-block-1 w-inline-block">
                                                    <div className="icon eye w-embed"><svg width="420" height="420" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M18.031 16.617L22.314 20.899L20.899 22.314L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875V15.875ZM12.178 7.176C11.8831 7.3092 11.625 7.51195 11.4257 7.76686C11.2264 8.02176 11.0919 8.32121 11.0338 8.63951C10.9757 8.95781 10.9957 9.28546 11.0921 9.59433C11.1885 9.90321 11.3583 10.1841 11.5871 10.4129C11.8159 10.6417 12.0968 10.8115 12.4057 10.9079C12.7145 11.0043 13.0422 11.0243 13.3605 10.9662C13.6788 10.9081 13.9782 10.7736 14.2331 10.5743C14.4881 10.375 14.6908 10.1169 14.824 9.822C15.0868 10.6756 15.0563 11.5926 14.7375 12.427C14.4186 13.2613 13.8297 13.9648 13.0646 14.4256C12.2994 14.8864 11.4021 15.0778 10.5155 14.9694C9.62896 14.8609 8.8042 14.4589 8.17264 13.8274C7.54108 13.1958 7.13906 12.371 7.03064 11.4845C6.92223 10.5979 7.11365 9.70058 7.5744 8.93544C8.03516 8.1703 8.73875 7.58138 9.57305 7.26252C10.4074 6.94366 11.3244 6.9132 12.178 7.176V7.176Z" fill="currentColor"></path>
                                                      </svg>
                                                    </div>
                                                  </a>
                                                  <a href="#" className="styled-a styled-a styled-a icon-link-block-2 w-inline-block">
                                                    <div className="icon cart w-embed"><svg width="420" height="420" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4 16V4H2V2H5C5.26522 2 5.51957 2.10536 5.70711 2.29289C5.89464 2.48043 6 2.73478 6 3V15H18.438L20.438 7H8V5H21.72C21.872 5 22.022 5.03466 22.1586 5.10134C22.2952 5.16801 22.4148 5.26495 22.5083 5.38479C22.6019 5.50462 22.6668 5.6442 22.6983 5.79291C22.7298 5.94162 22.7269 6.09555 22.69 6.243L20.19 16.243C20.1358 16.4592 20.011 16.6512 19.8352 16.7883C19.6595 16.9255 19.4429 17 19.22 17H5C4.73478 17 4.48043 16.8946 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16V16ZM6 23C5.46957 23 4.96086 22.7893 4.58579 22.4142C4.21071 22.0391 4 21.5304 4 21C4 20.4696 4.21071 19.9609 4.58579 19.5858C4.96086 19.2107 5.46957 19 6 19C6.53043 19 7.03914 19.2107 7.41421 19.5858C7.78929 19.9609 8 20.4696 8 21C8 21.5304 7.78929 22.0391 7.41421 22.4142C7.03914 22.7893 6.53043 23 6 23ZM18 23C17.4696 23 16.9609 22.7893 16.5858 22.4142C16.2107 22.0391 16 21.5304 16 21C16 20.4696 16.2107 19.9609 16.5858 19.5858C16.9609 19.2107 17.4696 19 18 19C18.5304 19 19.0391 19.2107 19.4142 19.5858C19.7893 19.9609 20 20.4696 20 21C20 21.5304 19.7893 22.0391 19.4142 22.4142C19.0391 22.7893 18.5304 23 18 23Z" fill="currentColor"></path>
                                                      </svg>
                                                    </div>
                                                  </a>
                                                </div><img  onClick={()=>window.location.href=x.url!=undefined ? x.url : "https://proberk.com"}  src={x.image ? x.image[0]:``} sizes="(max-width: 479px) 74vw, (max-width: 767px) 43vw, (max-width: 991px) 30vw, (max-width: 1439px) 21vw, 259.70703125px" alt="" className="product-card-image-1-1" />
                                              </div>
                                              <div className="product-card-content">
                                                <div className="mg-bottom-16px">
                                                  <h4 className="heading-h4-size">{x.name.replace("P-","").replace("S-","").replace("K-","").replace('K-','').replace('P-','').replace('S-','')}</h4>
                                                </div>
                                                <div className="mg-bottom-24px">
                                                  <p className="paragraph-text small">Ürün Kodu: {x.stock_code}</p>
                                                </div>
                                                <div className="btn-primary" style={{cursor:'pointer'}} onClick={()=>window.location.href=x.url!=undefined ? x.url : "https://proberk.com"}>Ürünü İncele</div>
                                              </div>
                                            </div>
                                          </li>
                                        )
                                      })
                                    }

                                  </ul>
                                </div>
                                <div className='btn-primary' onClick={()=>    getProducts(selectedCategory!=null ? selectedCategory.slug : (window.location.pathname.split("/")[window.location.pathname.split("/").length - 1]))} style={{cursor:'pointer'}}>
                                  Daha Fazla Göster<br/>
                                <ClipLoader color="#fff" loading={loading} />
                                </div>
                              </div>
                            }
                      
                    
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div className="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
    </div>
  );
}

export default App;
